import React from 'react';
import Mission from './Mission/Mission';
import History from './History/History';
import Structure from './Structure/Structure.jsx';
import Clients from './Clients/Clients';
import { Divider, Typography, Box } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
const useStyles = makeStyles((theme)=>({
    box: {
        padding: theme.spacing(1),
        background: '#378fe7',
        color: theme.palette.common.white,
        textAlign: "center",
        fontWeight: 500,
        marginTop: theme.spacing(11),
    },
}));
const Cmp = ({ lang }) => {
    window.scrollTo(0, 0);

    const classes = useStyles();

    return (
        <React.Fragment>
            <Box className={classes.box} >
                <Typography variant="h4" gutterBottom>
                    Centro Meteorológico Provincial
                </Typography>
                <Typography variant="h4">
                    Santiago de Cuba
                </Typography>
            </Box>
            <Mission lang={lang} parent={true} />
            <Divider />
            <History lang={lang} parent={true} />
            <Divider />
            <Structure lang={lang} />
            <Divider />
            <Clients lang={lang} />
        </React.Fragment>
    )
}

export default Cmp;